module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/083-somalia-cc3950d3eb8da5aeb67fe91ff65d2b02.svg";